import { DialogStore, Form, FormStore } from "@ariakit/react";
import { ReactNode } from "react";
import { atomic } from "../atomic.css";
import { DialogSubmitButton } from "../dialog-buttons";
import { DialogHeader } from "../dialog-header";
import { ModalDialog } from "../modal-dialog";
import { dialogContent } from "./style.css";

export function FormDialog(props: {
  form: FormStore;
  store?: DialogStore;
  children: ReactNode;
  heading: string;
  submitLabel: string;
}) {
  return (
    <ModalDialog store={props.store}>
      <Form
        store={props.form}
        autoComplete="off"
        className={dialogContent}
        resetOnSubmit={false}
      >
        <DialogHeader heading={props.heading} />

        <div
          className={atomic({
            display: "flex",
            flexDirection: "column",
            gap: 24,
          })}
        >
          {props.children}
        </div>

        <DialogSubmitButton>{props.submitLabel}</DialogSubmitButton>
      </Form>
    </ModalDialog>
  );
}
